import React from 'react';

export default (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.97664 9.33337H7.02284L6.66641 2.6667H9.33307L8.97664 9.33337ZM7.99974 13.3334C8.73612 13.3334 9.33307 12.7364 9.33307 12C9.33307 11.2637 8.73612 10.6667 7.99974 10.6667C7.26336 10.6667 6.66641 11.2637 6.66641 12C6.66641 12.7364 7.26336 13.3334 7.99974 13.3334Z" fill="#EF2530" />
  </svg>
);
